import { IEbayOffer, OrderPaymentStatus, PaymentMethodType, SaleSource } from "../../models/EbayOffer";

export default function OrderSaleSource({ offers }: { offers: IEbayOffer[] }) {

  const offer = offers[0];

  if (!offer) {
    return <span>Not Found</span>;
  }

  return (
    <span>{SaleSource[offer?.saleSource ?? SaleSource.eBay]}</span>
  );
}